import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

class Grid extends PureComponent {
    
    static propTypes = {
        content: PropTypes.array
    }

    state = {
        currentIndex: 0
    }

    setCurrentIndex = (index) => {
        this.setState({
            currentIndex: index
        });
    }
    
    render() {
        const { content } = this.props;
        const { currentIndex } = this.state;
        const first = content[0];
        const isMore = content.length > 5; // 超出5条就用更紧凑的模块，1+6模式

        return (
            <div className={styles.tabControl}>
                <div className={styles.left}>
                    <img src={formatImage(getThumbnail(first), 303, 205)} alt={first.title} />
                    <a className={styles.title} href={first.url} target="_blank" rel="noreferrer">
                        {first.title}
                    </a>
                    <div className={styles.content}>
                        {first.summary}
                        <a className={styles.cRed} href={first.url} target="_blank" rel="noreferrer">[详细]</a>
                    </div>
                </div>
                <div className={styles.right}>
                    {
                        content.slice(1, isMore ? 4 : 3).map((item, index) => {
                            return (
                                <div className={`${styles.tabs} ${isMore ? styles.more : ''} ${index === 0 ? styles.first : ''} ${index === currentIndex ? styles.active : ''}`} key={index} onClick={() => this.setCurrentIndex(index)}>
                                    <div className={styles.content}>
                                        <img src={getThumbnail(item)} alt={item.title} />
                                        <div className={styles.title}>
                                            <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                        </div>
                                    </div>
                                    <img className={`${styles.arrow} ${styles.up}`} src={require('../../assets/arrow_up.jpg')} alt="up" />
                                </div>
                            );
                        })
                    }
                    <div className={styles.center}>
                        <h2>
                            {content.slice(1)[currentIndex].title}
                        </h2>
                        <p>
                            {content.slice(1)[currentIndex].summary}
                        </p>
                    </div>
                    {
                        content.slice(isMore ? 4 : 3, isMore ? 7 : 6).map((item, index) => {
                            return (
                                <div className={`${styles.tabs} ${isMore ? styles.more : ''} ${index === 0 ? styles.first : ''} ${index + (isMore ? 3 : 2) === currentIndex ? styles.active : ''}`} key={index} onClick={() => this.setCurrentIndex(index + (isMore ? 3 : 2))}>
                                    <img className={`${styles.arrow} ${styles.down}`} src={require('../../assets/arrow_down.jpg')} alt="down" />
                                    <div className={styles.content}>
                                        <img src={getThumbnail(item)} alt={item.title} />
                                        <div className={styles.title}>
                                            <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Grid;
